import { useState } from 'react'

export const ActionButton = ({ onClick, className = '', disabled = false, title = '', children }) => {
    const [loading, setLoading] = useState(false)

    // The event goes through so a caller can read modifier keys (shift+click).
    const action = (event) => {
        setLoading(true)
        onClick(event).finally(() => setLoading(false))
    }

    return (
        <button
            onClick={action}
            className={[
                'flex flex-row items-center border border-white/20 py-1 pr-2 pl-3 enabled:hover:bg-gray-400/10 enabled:hover:border-white/50 rounded text-xs',
                className,
            ]
                .filter(Boolean)
                .join(' ')}
            disabled={disabled}
            title={title}
        >
            {children}
            <div
                className={['h-1 w-1 bg-blue-500 animate-pulse rounded-full translate-x-full', !loading && 'invisible']
                    .filter(Boolean)
                    .join(' ')}
            ></div>
        </button>
    )
}
